import { FC } from "react";

type Props = {
  data: any;
};

const styles = {
  container: {
    border: "1px solid #000",
    borderRadius: "12px",
    padding: "20px",
    fontFamily: "Arial",
    fontSize: "14px",
  },
  title: {
    fontWeight: 600,
    fontSize: "16px",
    marginBottom: "10px",
    borderBottom: "1px solid #000",
    paddingBottom: "5px",
  },
  section: {
    marginTop: "10px",
  },
};

const UserConsentPDF: FC<Props> = ({ data }) => {
  return (
    <div style={{ padding: 40 }}>
      <div style={styles.container}>
        <p style={styles.title}>CONSENT CONFIRMATION</p>

        <p>
          This document confirms that the user identified by{" "}
          <strong>User ID {data.user_id}</strong> has provided consent to the
          following policies within the system.
        </p>

        <div style={styles.section}>
          <strong>Accepted Policies:</strong>
          <ul>
            {data.terms_and_conditions && <li>Terms and Conditions</li>}
            {data.cookie_policy && <li>Cookie Policy</li>}
          </ul>
        </div>

        <div style={styles.section}>
          <strong>Consent Status:</strong>
          <ul>
            <li>
              Terms and Conditions:{" "}
              {data.terms_and_conditions ? "Accepted" : "Not Accepted"}
            </li>
            <li>
              Cookie Policy:{" "}
              {data.cookie_policy ? "Accepted" : "Not Accepted"}
            </li>
          </ul>
        </div>

        <div style={styles.section}>
          <strong>Record Details:</strong>
          <ul>
            <li>Record ID: {data.id}</li>
            <li>
              Created At: {new Date(data.created_at).toLocaleString()}
            </li>
            <li>
              Last Updated: {new Date(data.updated_at).toLocaleString()}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UserConsentPDF;